import { getRequest } from '../services/requestHandler';
import { PlayerYearLookup } from '../models';

export const getPlayerYearLookups = async () => {
  const url = 'player/getPlayerYearLookups?activeOnly=true&useCache=true';
  const response = await getRequest<PlayerYearLookup>('GetPlayerYearLookups', url);
  return response;
};
